"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpStandardPerformance = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var styled_components_1 = require("styled-components");
var has_1 = __importDefault(require("lodash/has"));
var react_i18next_1 = require("react-i18next");
var api_1 = require("../../../api");
var chartTypes_enum_1 = require("../Charts/chartTypes.enum");
var DpSectionCard_1 = require("../Cards/DpSectionCard");
var DpBarChartGrouped_1 = require("../BarChartGrouped/DpBarChartGrouped");
var DpStandardPerformance_styled_1 = require("./DpStandardPerformance.styled");
var DpCardHeader_1 = require("../CardHeader/DpCardHeader");
var DataTableModal_1 = require("../DataTableModal/DataTableModal");
var Icon_1 = require("../../Common/Icon/Icon");
var AtomicAlertManagerContext_1 = require("../AtomicAlert/AtomicAlertManagerContext");
var link_1 = __importDefault(require("next/link"));
var router_1 = require("next/router");
var themeBands = (_a = {},
    _a[api_1.Bands.NotProficient] = 'notYet',
    _a[api_1.Bands.PartiallyProficient] = 'partial',
    _a[api_1.Bands.HighlyProficient] = 'highlyProficient',
    _a[api_1.Bands.Proficient] = 'proficient',
    _a);
var baseDataset = {
    type: 'bar',
    maxBarThickness: 15,
    minBarThickness: 15,
    barPercentage: 0.9,
    categoryPercentage: 0.5,
};
var DpStandardPerformance = function (_a) {
    var activeClass = _a.activeClass, reportData = _a.reportData, standards = _a.standards;
    var t = (0, react_i18next_1.useTranslation)('common').t;
    // --------------------------- Context
    var themeContext = (0, react_1.useContext)(styled_components_1.ThemeContext);
    var analyticsService = (0, react_1.useContext)(api_1.ServiceContext).analyticsService;
    var toast = (0, react_1.useContext)(AtomicAlertManagerContext_1.AtomicAlertManagerContext).toast;
    var router = (0, router_1.useRouter)();
    var curriculumID = router.query.curriculumID;
    // --------------------------- State
    var _b = (0, react_1.useState)(false), initialized = _b[0], setInitialized = _b[1];
    var _c = (0, react_1.useState)(null), datasets = _c[0], setDatasets = _c[1];
    var _d = (0, react_1.useState)(null), labels = _d[0], setLabels = _d[1];
    var _e = (0, react_1.useState)(false), showStdPerformanceModal = _e[0], setshowStdPerformanceModal = _e[1];
    var _f = (0, react_1.useState)([]), standardPerformanceTableData = _f[0], setStandardPerformanceTableData = _f[1];
    var legendReferencesAndSeeAll = ((0, jsx_runtime_1.jsxs)("div", { className: "bottomWrapper", children: [(0, jsx_runtime_1.jsxs)("div", { className: "legend", children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("span", { className: "rounded-circle ny-proficient" }), (0, jsx_runtime_1.jsx)("span", { className: "title", children: t('standardPerformance.notYetProficient') })] }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("span", { className: "rounded-circle p-proficient" }), (0, jsx_runtime_1.jsx)("span", { className: "title", children: t('standardPerformance.partiallyProficient') })] }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("span", { className: "rounded-circle proficient" }), (0, jsx_runtime_1.jsx)("span", { className: "title", children: t('standardPerformance.proficient') })] }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("span", { className: "rounded-circle h-proficient" }), (0, jsx_runtime_1.jsx)("span", { className: "title", children: t('standardPerformance.highlyProficient') })] })] }), (0, jsx_runtime_1.jsxs)("div", { className: "link-container", children: [(0, jsx_runtime_1.jsx)(link_1.default, { "aria-label": t('standardPerformance.seeAllAriaLabel'), href: "/reports/standards/".concat(activeClass, "?curriculumID=").concat(curriculumID), legacyBehavior: false, prefetch: false, children: t('standardPerformance.link') }), (0, jsx_runtime_1.jsx)(Icon_1.Icon, { name: "arrow-front" })] })] }));
    var headers = [
        {
            headerName: t('standardPerformance.standard'),
            key: 'standard',
            sortable: true,
        },
        {
            headerName: t('standardPerformance.quantity'),
            key: 'quantity',
        },
        {
            headerName: t('standardPerformance.notYetProficient'),
            key: 'not-proficient',
        },
        {
            headerName: t('standardPerformance.partiallyProficient'),
            key: 'partially-proficient',
        },
        {
            headerName: t('standardPerformance.proficient'),
            key: 'proficient',
        },
        {
            headerName: t('standardPerformance.highlyProficient'),
            key: 'highly-proficient',
        },
    ];
    var closeModal = function () {
        setshowStdPerformanceModal(false);
    };
    var openReport = function () {
        setshowStdPerformanceModal(true);
    };
    var title = (0, jsx_runtime_1.jsx)(DpCardHeader_1.DpCardHeader, { title: t('standardPerformance.title'), openReport: openReport });
    // --------------------------- Methods
    /**
     * Receives an array of items and with the data it builds and
     * returns an array of LabelsTuples
     *
     * @param PerformanceDistributions       - Array of distribution items
     */
    var buildLabels = (0, react_1.useCallback)(function (performanceDistributions) {
        return performanceDistributions.map(function (_a) {
            var standard = _a.standard, totalItems = _a.totalItems;
            return [
                (0, api_1.getShortCodeFromGlobalId)(standard),
                totalItems,
            ];
        });
    }, []);
    /**
     * Receives an array of items and with the data it builds and returns an array of datasets
     *
     * @param PerformanceDistributions       - Array of distribution items
     *
     * {
     *    type: 'bar',
     *    maxBarThickness: 15,
     *    minBarThickness: 15,
     *    barPercentage: 0.9,
     *    categoryPercentage: 0.5,
     *    data: [],
     *    backgroundColor: bandColor,
     *    hoverBackgroundColor: bandColor,
     * }
     */
    var buildDatasets = (0, react_1.useCallback)(function (PerformanceDistributions) {
        var performanceTableData = [];
        var datasetsByBand = PerformanceDistributions.reduce(function (result, standard, index) {
            performanceTableData[index] = {
                standard: (0, api_1.getShortCodeFromGlobalId)(standard.standard),
                quantity: standard.totalItems,
            };
            standard.distribution.forEach(function (distributionItem) {
                if (!(0, has_1.default)(result, distributionItem.band.code)) {
                    var bandColor = (0, api_1.findPerformanceBandColor)(themeContext, (0, api_1.getCurriculumPrefixFromCurriculum)(distributionItem.band.curriculum), themeBands[distributionItem.band.code]);
                    result[distributionItem.band.code] = __assign({ data: [], backgroundColor: bandColor, hoverBackgroundColor: bandColor }, baseDataset);
                }
                result[distributionItem.band.code].data = __spreadArray(__spreadArray([], result[distributionItem.band.code].data, true), [
                    (0, api_1.formatPercentage)(distributionItem.percentage),
                ], false);
                performanceTableData[index][distributionItem.band.code] = "".concat((0, api_1.formatPercentage)(distributionItem.percentage), "%");
            });
            return result;
        }, {});
        setStandardPerformanceTableData(performanceTableData);
        return Object.values(datasetsByBand);
    }, [themeContext]);
    var setStates = (0, react_1.useCallback)(function (bandsDistribution) {
        var standardsToShow = bandsDistribution.slice(0, 7);
        setLabels(buildLabels(standardsToShow));
        setDatasets(buildDatasets(standardsToShow));
        setInitialized(true);
    }, [buildDatasets, buildLabels]);
    // --------------------------- SDK Calls
    /**
     * Fetches data from the service getStandardsPerformanceBandDistribution
     */
    var fetchStandardPerformanceData = (0, react_1.useCallback)(function () {
        analyticsService
            .getStandardsPerformanceBandDistribution(reportData.assigneeStandardPerformances, reportData.bands, standards)
            .then(function (bandsDistribution) {
            setStates(bandsDistribution);
        })
            .catch(function () {
            toast({
                alertVariant: 'error',
                content: {
                    title: t('errorMessages.oopsErr'),
                    message: t('errorMessages.standardsData'),
                },
            });
            setInitialized(true);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [analyticsService, setStates, reportData, standards]);
    (0, react_1.useEffect)(function () {
        fetchStandardPerformanceData();
    }, [fetchStandardPerformanceData, standards]);
    return (initialized && ((0, jsx_runtime_1.jsx)(DpStandardPerformance_styled_1.StyledStandardPerformance, { "data-testid": "standard-performance", children: (0, jsx_runtime_1.jsx)(DpSectionCard_1.DpSectionCard, { title: title, children: (0, jsx_runtime_1.jsxs)("div", { className: "report", children: [(0, jsx_runtime_1.jsx)(DpBarChartGrouped_1.DpBarChartGrouped, { labels: labels || [], ariaLabel: t('standardPerformance.chartAriaLabel', { count: (labels === null || labels === void 0 ? void 0 : labels.length) || 0 }), type: chartTypes_enum_1.LibraryChartTypes.Bar, id: "grouped-standard-performance", datasets: datasets || [] }), legendReferencesAndSeeAll, (0, jsx_runtime_1.jsx)(DataTableModal_1.DataTableModal, { show: showStdPerformanceModal, closeHandler: closeModal, title: t('standardPerformance.title'), tableData: standardPerformanceTableData, headers: headers })] }) }) })));
};
exports.DpStandardPerformance = DpStandardPerformance;
exports.default = exports.DpStandardPerformance;
